import { callBackendApiPost } from '../../lib/api';
import { formatDataNoPhotos } from '../../lib/formatting';

let isUpdating = false;

const saveProgressMiddleware = store => next => action => {
    if (action._processed || action.type === 'user/setCaseId' || action.type === 'user/setPatientID') {
        return next(action);
    }

    if (
        action.type &&
        (/(user|insurance|stripe)\/set.*/.test(action.type) || action.type === 'user/markUserUpdateReady')
    ) {
        const exclusion = [
            "setTellescopeID",
            "setBooked",
            "setPhotos",
            "setOtpCode",
            "setCardFront",
            "setCardBack",
            "setUserFromAbandonedCart"
        ];

        if (exclusion.includes(action.type.split("/")[1])) {
            return next(action);
        }

        const result = next(action);

        setTimeout(() => {
            if (isUpdating) return;

            const state = store.getState();
            const { user } = state;

            if (
                !user.phoneNo ||
                !user.email ||
                !user.firstName ||
                !user.lastName ||
                !user.dob
            ) {
                return;
            }

            if (user.returning === true) {
                // const data = formatDataNoPhotosReturning(state.user, state.insurance, state.stripe);
                // TBD - api call for partial progress of returning patient data
                return;
            }

            if (user.photosUpload === true) {
                return;
            }

            if (!user.readyToPersist) return;


            if (user.portal === true &&
                (action.type === 'user/setAllPatientData' ||
                    action.type === 'insurance/setAllPatientInsuranceData' ||
                    action.type === 'user/setPreviousCaseId' ||
                    action.type === 'user/setCurrentPage' ||
                    action.type === 'user/setReturning' ||
                    action.type === 'user/setConcern' ||
                    action.type === 'user/setRetIntakeId')) {
                return;
            }

            isUpdating = true;

            const data = formatDataNoPhotos(user, state.insurance, state.stripe);

            callBackendApiPost('/api/v1/update', data)
                .then(response => response.json())
                .then(data => {
                    if (data?.case?.id && !user.caseID) {
                        store.dispatch({
                            type: 'user/setCaseId',
                            payload: data.case.id,
                            _processed: true
                        });
                    }
                    if (data?.case?.id && !user.patientID) {
                        store.dispatch({
                            type: 'user/setPatientID',
                            payload: data.patient.id,
                            _processed: true
                        });
                    }
                })
                .catch(error => {
                    console.error('Error updating progress:', error);
                })
                .finally(() => {
                    isUpdating = false;
                });
        }, 0);

        return result;
    }

    return next(action);
};

export default saveProgressMiddleware;